export function normalizeApproveFileList(fileList) {
  return (fileList || [])
    .map(file => {
      if (!file) return ''
      if (typeof file === 'string') return file
      return file.fileId || ''
    })
    .filter(Boolean)
}

export function buildApproveContent(specialDialog) {
  const applyReason = ((specialDialog && specialDialog.applyReason) || '').trim()
  if (!applyReason) {
    return null
  }

  return {
    applyMatter: ((specialDialog && specialDialog.applyMatter) || '').trim(),
    applyReason,
    fileList: normalizeApproveFileList(specialDialog && specialDialog.fileList)
  }
}
